export default __webpack_public_path__ + "static/media/KGDenimBG.fad8501b.webp";